'use strict';

var react = require('@sentry/react');
var constants = require('./constants.cjs');
var routeTo = require('./routeTo.cjs');

const transport = react.makeMultiplexedTransport(react.makeFetchTransport, (args) => {
  const event = args.getEvent();
  if (event && event.extra && constants.EVENT_EXTRA_KEY_FOR_ROUTE_TO in event.extra && isRouteToArray(event.extra[constants.EVENT_EXTRA_KEY_FOR_ROUTE_TO])) {
    return event.extra[constants.EVENT_EXTRA_KEY_FOR_ROUTE_TO];
  }
  return [];
});
function isRouteToArray(value) {
  if (!Array.isArray(value)) {
    return false;
  }
  return value.every(routeTo.isRouteTo);
}

exports.transport = transport;
//# sourceMappingURL=transport.cjs.map
